<template>
  <section class="page-user-form">
    <div class="content">
      <rp-edit-operation
        :hospitals="hospitals"
        :surgeons="surgeons"
        :iolModels="iolModels"
        :leftIolPowers="iolPowers.left"
        :leftDuetIolPowers="iolPowers.leftDUET"
        :rightIolPowers="iolPowers.right"
        :rightDuetIolPowers="iolPowers.rightDUET"
        :leftCylPowers="cylPowers.left"
        :leftDuetCylPowers="cylPowers.leftDUET"
        :rightCylPowers="cylPowers.right"
        :rightDuetCylPowers="cylPowers.rightDUET"
        :operationIsNew=false
        @getHospitals="getHospitals"
        @getSurgeons="getSurgeons"
        @getIolModels="getIolModels"
        @getIolPowers="getIolPowers"
        @submit="submit"
        v-model="operation"/>

        <terms/>
      </div>
  </section>
</template>

<script>
  import EditOperationForm from 'raypro_ui/src/components/ui/forms/Operation'
  import {getIolModels, getIolPowers} from 'raypro_ui/src/api/iols'
  import {getHospitals} from 'raypro_ui/src/api/hospitals'
  import {getOperationById, updateOperation} from 'raypro_ui/src/api/operations'
  import {getAssociatedSurgeons, getUserHospitals} from 'raypro_ui/src/api/users'
  import {mapGetters} from 'vuex'

  import page from '@/mixins/page'
  import Terms from '@/components/Terms'

  export default {
    data() {
      return {
        errors: {},
        lastChar: 10,
        timeString: 'T12:00:00Z',
        form: {},
        operation: {},
        surgeons: [],
        iolModels: [],
        iolPowers: {
          left: [],
          right: [],
          leftDUET: [],
          rightDUET: []
        },
        cylPowers: {
          left: [],
          right: [],
          leftDUET: [],
          rightDUET: []
        },
        hospitals: [],
        title: 'Edit Surgery'
      }
    },

    mixins: [page],

    async mounted() {
      await this.getSurgeons()
      getOperationById(this.$props).then(({data}) => {
        // TODO: fix this.lastchar
        this.operation = {
          aeon_drops_provided: data.aeon_drops_provided,
          blended_vision: data.blended_vision,
          complex_surgery: data.complex_surgery,
          performed_at: data.performed_at.slice(0, this.lastChar),
          patient_ref: data.patient_ref,
          surgeon_id: data.surgeon.id,
          hospital_id: data.hospital.id,
          operation_iols: [],
          leftEye: '',
          iol_model_left: '',
          iol_power_left: '',
          iol_power_left_cyl: '',
          iol_model_left_duet: '',
          iol_power_left_duet: '',
          iol_power_left_cyl_duet: '',
          rightEye: '',
          iol_model_right: '',
          iol_power_right: '',
          iol_power_right_cyl: '',
          iol_model_right_duet: '',
          iol_power_right_duet: '',
          iol_power_right_cyl_duet: ''
        }

        new Array(true, false).forEach((x) => this.initIols(data, x));
      })
    },

    computed: {
      ...mapGetters(['authUser']),

      operationPayload() {
        const operation = this.operation
        // TODO: fix this.timeString

        return {
          id: this.id,
          data: {
            operation: {
              aeon_drops_provided: operation.aeon_drops_provided,
              blended_vision: operation.blended_vision,
              complex_surgery: operation.complex_surgery,
              performed_at: operation.performed_at + this.timeString,
              patient_ref: operation.patient_ref,
              surgeon_id: operation.surgeon_id,
              hospital_id: operation.hospital_id,
              operation_iols: operation.operation_iols,
            }
          }
        }
      },
    },

    props: {id: String},

    components: {
      'rp-edit-operation': EditOperationForm,
      Terms
    },

    methods: {

      initIols(data, isLeft) {

        let mainIol = null;
        let duetIol = null;
        const side = (isLeft) ? 'left' : 'right';
        const iols = data.operation_iols.filter((iol) => iol.eye === side.charAt(0).toUpperCase());

        if (iols.length === 2) {
          mainIol = iols.filter((iol) => iol.iol.model.includes('DUET'))[0];
          duetIol = iols.filter((iol) => !iol.iol.model.includes('DUET'))[0];
        } else if (iols.length === 1) {
          mainIol = iols[0];
        }

        this.operation[side + 'Eye'] = !!mainIol;
        this.operation['iol_model_' + side] = (mainIol) ? mainIol.iol.id : '';
        this.operation['iol_model_' + side + '_duet'] = (duetIol) ? duetIol.iol.id : '';
        this.operation['iol_power_' + side] = (mainIol) ?
          mainIol.power.filter((pow) => !pow.includes('(Cyl)')).length === 1 ?
          mainIol.power.filter((pow) => !pow.includes('(Cyl)'))[0] : '' : '';
        this.operation['iol_power_' + side + '_cyl'] = (mainIol) ?
          mainIol.power.filter((pow) => pow.includes('(Cyl)')).length === 1 ?
          mainIol.power.filter((pow) => pow.includes('(Cyl)'))[0] : '' : '';
        this.operation['iol_power_' + side + '_duet'] = (duetIol) ?
          duetIol.power.filter((pow) => !pow.includes('(Cyl)')).length === 1 ?
          duetIol.power.filter((pow) => !pow.includes('(Cyl)'))[0] : '' : '';
        this.operation['iol_power_' + side + '_cyl_duet'] = (duetIol) ?
          duetIol.power.filter((pow) => pow.includes('(Cyl)')).length === 1 ?
          duetIol.power.filter((pow) => pow.includes('(Cyl)'))[0] : '' : '';
      },

      /*getHospitals() {
        getHospitals()
          .then(({data}) => {
            this.hospitals = data
          })
          .catch(() => {
          })
      },*/
      getHospitals() {
        const userId = this.operation.surgeon_id
        getUserHospitals({id: userId}).then(({data}) => {
          this.hospitals = data
        })
        .catch(() => {
        })
      },

      async getSurgeons() {
        const userId = this.authUser.id
        let data = await getAssociatedSurgeons({userId})
        this.surgeons = data.data
      },

      /*getIolModels() {
        getIolModels()
          .then(({data}) => {
            this.iolModels = data
          })
          .catch(() => {
          })
      },*/
      getIolModels(isPlus) {
        getIolModels()
          .then(({data}) => {
            if (isPlus) {
              this.iolModels = data
            }
            else {
              this.iolModels = data.filter((x) => x.manufacturer === 'Rayner')
            }
          })
          .catch(({data}) => {
          })
      },

      getIolPowers(iolParams) {
        getIolPowers(iolParams)
          .then(({data}) => {
            let powers = data.powers
            if (powers === undefined) {powers = []}
            this.iolPowers[iolParams.type] = powers.filter((power) => {
              return !power.includes('(Cyl)')
            })

            this.cylPowers[iolParams.type] = powers.filter((power) => {
              return power.includes('(Cyl)')
            })
          })
      },

      submit() {
        this.setOperationIols()
        updateOperation(this.operationPayload)
          .then(() => {
            this.$router.push({name: 'all-operations'})
          })
          .catch(() => {
          })
      },

      setOperationIols() {
        if (this.operation.iol_model_left) {
          this.operation.operation_iols.push(this.operationIolCreator(
            this.operation.iol_power_left, this.operation.iol_power_left_cyl, 'L', this.operation.iol_model_left
          ))
        }
        
        if (this.operation.iol_model_left_duet) {
          this.operation.operation_iols.push(this.operationIolCreator(
            this.operation.iol_power_left_duet, this.operation.iol_power_left_cyl_duet, 'L', this.operation.iol_model_left_duet
          ))
        }

        if (this.operation.iol_model_right) {
          this.operation.operation_iols.push(this.operationIolCreator(
            this.operation.iol_power_right, this.operation.iol_power_right_cyl, 'R', this.operation.iol_model_right
          ))
        }

        if (this.operation.iol_model_right_duet) {
          this.operation.operation_iols.push(this.operationIolCreator(
            this.operation.iol_power_right_duet, this.operation.iol_power_right_cyl_duet, 'R', this.operation.iol_model_right_duet
          ))
        }
      },

      operationIolCreator(power, powerCyl, eye, modelId) {
        let powers = []
        if (power) powers.push(power)
        if (powerCyl) powers.push(powerCyl)
        return {
          power: powers,
          eye: eye,
          iol_id: modelId
        }
      },
    }
  }
</script>

<style lang="sass">
  .page-user-form
</style>



// WEBPACK FOOTER //
// src/components/pages/Operations/EditOperation.vue